module.exports = __webpack_public_path__ + "img/s3-5.d8b00f19.jpg";